import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

//auth components
import LogIn from "../components/auth/LogIn.vue";
import RegisterAdmin from "../components/auth/RegisterAdmin.vue";
import Register from "../components/auth/RegisterTeacher.vue";
import NoAccess from "../components/auth/NoAccess.vue";
import Error404 from "../components/auth/Error404.vue";
import Restricted from "../components/auth/RestrictedPage.vue";
import UserProfile from "../components/auth/UserProfile.vue";
import ResetPassword from "../components/auth/ResetPassword.vue";

//admin components
import Users from "../components/admin/users/Users.vue";
import AdminTopics from "../components/admin/Topics.vue";
import Courses from "../components/admin/Courses.vue";


//normal-user components
import NormalUserTopics from "../components/normal-user/TopicsNormalUser.vue";
import TopicPage from "../components/normal-user/TopicPage.vue";
import ContactForm from "../components/normal-user/ContactForm.vue";

//store
import store from "../store/index.js";
import { findLastKey } from "lodash-es";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
      requiresUserLevel: 10,
      requireSuspendUserFalse: true,
    },
  },
  //auth routes
  {
    path: "/login",
    name: "LogIn",
    component: LogIn,
  },
  {
    path: "/register-admin",
    name: "RegisterAdmin",
    component: RegisterAdmin,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/verify-email",
    name: "verifyemail",
    component: NoAccess,
  },
  {
    path: "/restricted",
    name: "restricted",
    component: Restricted,
  },
  {
    path: "*",
    name: "error404",
    component: Error404,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
  },
  {
    path: "/user-account",
    name: "UserAccount",
    component: UserProfile,
    meta: {
      requiresAuth: true,
      requiresUserLevel: 10,
      requireSuspendUserFalse: true,
    },
  },
  //admin routes
  {
    path: "/admin/users",
    name: "Users",
    component: Users,
    meta: {
      requiresAuth: true,
      requiresUserLevel: 100,
      requireSuspendUserFalse: true,
    },
  },
  {
    path: "/admin/topics",
    name: "AdminTopics",
    component: AdminTopics,
    meta: {
      requiresAuth: true,
      requiresUserLevel: 100,
      requireSuspendUserFalse: true,
    },
  },
  {
    path: "/admin/courses",
    name: "Courses",
    component: Courses,
    meta: {
      requiresAuth: true,
      requiresUserLevel: 100,
      requireSuspendUserFalse: true,
    },
  },
  //normal-user routes
  {
    path: "/topics",
    name: "NormalUserTopics",
    component: NormalUserTopics,
    meta: {
      requiresAuth: true,
      requiresUserLevel: 10,
      requireSuspendUserFalse: true,
    },
  },
  {
    path: "/topics/topic/:id",
    name: "TopicPage",
    component: TopicPage,
    meta: {
      requiresAuth: true,
      requiresUserLevel: 10,
      requireSuspendUserFalse: true,
    },
  },
  {
    path: "/contactform",
    name: "ContactForm",
    component: ContactForm,
    meta: {
      requiresAuth: true,
      requiresUserLevel: 10,
      requireSuspendUserFalse: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  //const userLevel = to.matched.find(record => record.meta.requiresUserLevel).meta.requiresUserLevel;
  //const requiresUserLevel = to.matched.some(record => record.meta.requiresUserLevel);

  if (requiresAuth) {
    let checkUser = store.getters.currUser;
    //console.log("CURR USER ROUTER: " + JSON.stringify(checkUser, null, 2));
    if (!checkUser || checkUser === []) {
     // console.log('not logged in')
      next("/login");
    } else 
    if(checkUser.suspendUser === true){
      next("restricted");
    }
    else{
      const userLevel = to.matched.find((record) => record.meta.requiresUserLevel).meta.requiresUserLevel;
      //console.log("userLevel: " + userLevel);

      const requiresUserLevel = to.matched.some((record) => record.meta.requiresUserLevel);

      const requireSuspendUserFalse = to.matched.some((record) => record.meta.requireSuspendUserFalse);
      if (requiresUserLevel && parseInt(checkUser.userTypeId) < userLevel) {
      //   console.log("forbidden access");
        next("restricted");
      }
      //  else if( requireSuspendUserFalse===true && checkUser.suspendUser === requireSuspendUserFalse ){
      //   next("restricted");
      //   return;
      // }
      next();
    }

  } else next();
});

export default router;
